import { Check } from "lucide-react";

export function MembershipTiers({ tiers, selected, onSelect, compact = false }) {
  return (
    <div className={`grid gap-4 ${compact ? "sm:grid-cols-2" : "md:grid-cols-2"}`} data-testid="membership-tiers">
      {tiers.map((t) => {
        const active = selected === t.id;
        const plus = t.id === "care_plus";
        return (
          <button key={t.id} type="button" onClick={() => onSelect?.(t.id)} data-testid={`membership-tier-${t.id}`}
            className={`relative text-left rounded-2xl border p-6 transition-colors ${active ? "border-[#FFD600] bg-[#FFD600]/10" : "border-slate-800 bg-slate-900/40 hover:border-[#FFD600]/60"}`}>
            {plus && <span className="absolute -top-3 left-6 dg-chip bg-[#FFD600] text-slate-900 border-[#FFD600]">Most popular</span>}
            <div className="flex items-baseline justify-between gap-3">
              <div className="font-display font-bold text-lg">{t.name}</div>
              <div className="font-display font-extrabold text-2xl text-[#FFD600]">${Number(t.price_usd).toFixed(0)}<span className="text-sm text-slate-400 font-normal">/mo</span></div>
            </div>
            <div className="text-sm text-slate-400 mt-1">{t.tagline}</div>
            <ul className="mt-4 space-y-2 text-sm text-slate-200">
              {t.perks.map((p) => <li key={p} className="flex items-start gap-2"><Check className="w-4 h-4 text-[#FFD600] mt-0.5 shrink-0" /> {p}</li>)}
            </ul>
          </button>
        );
      })}
    </div>
  );
}
